import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { typography, fontWeights } from '../../../styles/typography';
import { MediaQueries } from '../../../styles/Grid';

export const spacerMargin = css({
  marginTop: 64,
  marginBottom: 80,
  [MediaQueries.mdAndUp]: {
    marginTop: 96,
  },
  [MediaQueries.lgAndUp]: {
    marginTop: 160,
  },
});

export const container = css({
  paddingBottom: 24,
  marginBottom: 22,
  borderBottom: `1px solid ${colorsPalette.grey20}`,
  [MediaQueries.mdAndUp]: {
    marginBottom: 24,
  },
});

export const headline = css({
  fontSize: 48,
  lineHeight: 1.17,
  letterSpacing: -1,
  color: colorsPalette.black,
  marginBottom: 40,
  fontWeight: fontWeights.medium,
  [MediaQueries.mdAndUp]: {
    marginBottom: 56,
  },
});

// Simulates right column since it's complicated to apply grid sizes inside Swiper
export const featureContainer = css({
  boxSizing: 'border-box',
  [MediaQueries.mdAndUp]: {
    paddingRight: 90,
  },
  [MediaQueries.lgAndUp]: {
    paddingRight: 80,
  },
  [MediaQueries.xl]: {
    paddingRight: 110,
  },
});

export const featureTitle = css(typography.effra22, {
  fontWeight: fontWeights.medium,
  color: colorsPalette.black,
  marginTop: 18,
  marginBottom: 8,
});

export const featureDescription = css(typography.effra18, {
  lineHeight: 1.67,
  color: colorsPalette.grey80,
  marginBottom: 19,

  '&:last-child': {
    marginBottom: 0,
  },
});

export const swiperContainer = css({
  position: 'relative',
  '.swiper-wrapper': {
    paddingBottom: 76,
    [MediaQueries.lgAndUp]: {
      paddingBottom: 90,
    },
  },
  '.key-features-swiper-pagination': {
    textAlign: 'right',
    position: 'absolute',
    bottom: 14,
    right: 0,
  },
});

export const arrowButtons = {
  container: css({
    position: 'absolute',
    bottom: 0,
    zIndex: 1,
  }),
};

export const moduleCTA = css(typography.effra16, {});
